export default {
    view_cerebrumx_integration_title: "CerebrumX Integración",
    view_cerebrumx_integration_success_message: "El perfil ha sido actualizado correctamente",
    view_cerebrumx_integration_error_message: "No se ha podido actualizar el perfil debido a un error",
    view_cerebrumx_integration_cerebrumX: "CerebrumX",
    view_cerebrumx_integration_diesellaptops: "Diesel Laptops",
    view_cerebrumx_integration_info: "Información",
    view_cerebrumx_integration_thresholds: "Umbrales",
    view_cerebrumx_integration_cerebrumx: "CerebrumX",
    view_cerebrumx_integration_fleet: "Flota",
    view_cerebrumx_integration_fleet_id: "Id de Flota",
    view_cerebrumx_integration_status: "Estado",
    view_cerebrumx_integration_oems: "OEMs",
    view_cerebrumx_integration_harsh_acceleration: "Aceleración Brusca",
    view_cerebrumx_integration_harsh_acceleration_range: "El valor debe estar entre 2 y 5",
    view_cerebrumx_integration_harsh_breaking: "Frenada Brusca",
    view_cerebrumx_integration_harsh_breaking_range: "El valor debe estar entre -5 y -2",
    view_cerebrumx_integration_harsh_cornering: "Curvas Pronunciadas",
    view_cerebrumx_integration_harsh_cornering_range: "El valor debe estar entre 2 y 5",
    view_cerebrumx_integration_overspeeding: "Exceso de velocidad",
    view_cerebrumx_integration_overspeeding_range: "El limite de velocidad debe estar entre 40 - 150 mph",
    view_cerebrumx_integration_idling: "Ralentí",
    view_cerebrumx_integration_idling_range: "La duración minima de ralentí debería ser 60 segundos",
    view_cerebrumx_integration_ms_square: "m/s²",
    view_cerebrumx_integration_mph: "mph",
    view_cerebrumx_integration_sec: "seg",
    view_cerebrumx_integration_add_oem: "Adicionar OEM",
    view_cerebrumx_integration_save_profiles: "Guardar perfiles"
    

}